var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 80,
    viewBox: "0 0 85 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0886 62.7646L57.1588 71.8348C59.3526 71.8965 61.1146 73.6995 61.1146 75.914C61.1146 78.1695 59.2909 79.9931 57.0354 79.9931C54.7798 79.9931 52.9562 78.1627 52.9562 75.914C52.9562 75.6672 52.9768 75.4203 53.0179 75.1804L45.1269 67.2963V73.0962H39.4777V67.4539L31.4633 75.4752C31.4771 75.6192 31.4839 75.77 31.4839 75.9208C31.4839 78.1764 29.6603 80 27.3979 80C25.1423 80 23.3187 78.1695 23.3187 75.9208C23.3187 73.6653 25.1492 71.8416 27.3979 71.8416C27.4664 71.8416 27.535 71.8416 27.5967 71.8485L36.6669 62.7783L0.42041 62.7646V10.7704C0.42041 10.7361 0.42041 10.7087 0.42041 10.6744V5.15554C0.42041 4.55909 0.914026 4.07918 1.52419 4.07918H39.4777V0H45.1269V4.07918H83.5604C84.1705 4.07918 84.6641 4.56594 84.6641 5.15554V10.6744C84.6641 10.695 84.6641 10.7087 84.6641 10.7293V62.7577H48.0886V62.7646ZM18.8556 42.9925L34.8021 27.4025C38.751 31.3514 42.6588 35.2592 46.6489 39.2013L57.2136 28.5063L52.3118 23.6044L66.1056 23.481V37.3914L61.3956 32.6815C56.4869 37.6519 51.5987 42.6086 46.6763 47.5379L34.7198 35.7323L23.0376 47.1746L18.8556 42.9925ZM78.4322 14.8976H6.53576V56.471H78.4322V14.8976Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV1);
export default __webpack_public_path__ + "static/media/v1.e323e15b7bb27d60794c47429179a429.svg";
export { ForwardRef as ReactComponent };